import { CLINIC_NAME, CLINIC_SHORT_NAME } from '../constants';

const BENEFITS = [
  { icon: '🏢', title: 'Fully-Furnished Rooms', desc: 'Premium consultation suites with examination beds, ergonomic workstations — ready from day one.' },
  { icon: '📅', title: 'Flexible Scheduling', desc: 'Daily, weekly or long-term. Arrangements tailored entirely to your practice needs.' },
  { icon: '👩‍⚕️', title: 'Support Staff Included', desc: 'Dedicated nursing and administrative support so you focus entirely on patient care.' },
  { icon: '💊', title: 'In-House Pharmacy & Lab', desc: 'Your patients get prescriptions filled and tests done on-site — same visit.' },
  { icon: '📈', title: 'Grow Your Practice', desc: 'Access a walk-in patient base, referral network and a professional environment.' },
  { icon: '🏥', title: 'Modern Infrastructure', desc: 'AC, lift, advanced machinery and premium interiors throughout the facility.' },
];

const SPECIALTIES = [
  'General Medicine','Cardiology','Orthopedics','Dermatology',
  'Pediatrics','Gynecology','Neurology','Ophthalmology',
  'ENT','Psychiatry','Urology','Gastroenterology',
  'Endocrinology','Dentistry','Physiotherapy','Dietetics',
];

export default function Practitioners({ onNav }) {
  const go = (id) => { onNav(id); window.scrollTo({ top: 0, behavior: 'smooth' }); };
  return (
    <>
      <style>{`
        .pr-hero {
          padding: 120px 0 64px; background: var(--charcoal); position: relative; overflow: hidden;
        }
        .pr-hero::before {
          content:''; position:absolute; inset:0;
          background: radial-gradient(circle at 75% 40%, rgba(30,58,95,0.09) 0%, transparent 55%);
        }
        .pr-hero-inner { position: relative; }
        .pr-hero-btns { display: flex; gap: 12px; flex-wrap: wrap; margin-top: 28px; }

        .benefits-section { background: var(--sand); }
        .benefits-grid {
          display: grid; grid-template-columns: repeat(3,1fr); gap: 18px; margin-top: 36px;
        }
        .ben-card {
          background: var(--white); border: 1px solid var(--border);
          border-radius: var(--radius); padding: 26px; transition: all 0.22s;
        }
        .ben-card:hover { transform: translateY(-2px); box-shadow: var(--shadow-md); border-color: rgba(30,58,95,0.2); }
        .ben-icon {
          width: 42px; height: 42px; border-radius: 9px;
          background: var(--terra-pale); border: 1px solid rgba(30,58,95,0.15);
          display: flex; align-items: center; justify-content: center;
          font-size: 19px; margin-bottom: 14px;
        }
        .ben-title { font-size: 14.5px; font-weight: 600; color: var(--charcoal); margin-bottom: 6px; }
        .ben-desc { font-size: 13px; color: var(--text-muted); line-height: 1.65; }

        .room-showcase { background: var(--white); }
        .room-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0; border: 1px solid var(--border); border-radius: var(--radius); overflow: hidden; margin-top: 36px; }
        .room-img-side { aspect-ratio: 4/3; }
        .room-img-side img { width: 100%; height: 100%; object-fit: cover; }
        .room-info-side { padding: 36px 32px; display: flex; flex-direction: column; justify-content: center; }
        .room-info-title { font-family: var(--font-display); font-size: 28px; font-weight: 600; color: var(--charcoal); margin-bottom: 10px; }
        .room-info-desc { font-size: 14px; color: var(--text-muted); line-height: 1.75; margin-bottom: 20px; }
        .room-tags { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 24px; }
        .r-tag { padding: 5px 12px; border-radius: 4px; font-size: 12px; background: var(--terra-pale); color: var(--terra); border: 1px solid rgba(30,58,95,0.15); }

        .spec-section { background: var(--sand-mid); }
        .spec-tags { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 28px; }
        .spec-tag {
          padding: 7px 16px; border-radius: 20px;
          border: 1px solid var(--border); background: var(--white);
          font-size: 13px; color: var(--text-mid); transition: all 0.18s;
        }
        .spec-tag:hover { border-color: var(--terra); color: var(--terra); background: var(--terra-pale); }

        .join-section { background: var(--white); }
        .join-steps {
          display: grid; grid-template-columns: repeat(3,1fr); gap: 0;
          border: 1px solid var(--border); border-radius: var(--radius);
          overflow: hidden; margin-top: 36px;
        }
        .j-step {
          padding: 32px 24px; border-right: 1px solid var(--border);
          background: var(--sand);
        }
        .j-step:last-child { border-right: none; }
        .j-num { font-family: var(--font-display); font-size: 42px; font-weight: 600; color: var(--terra); opacity: 0.2; line-height: 1; margin-bottom: 12px; }
        .j-title { font-size: 15px; font-weight: 600; color: var(--charcoal); margin-bottom: 6px; }
        .j-desc { font-size: 13px; color: var(--text-muted); line-height: 1.7; }

        @media (max-width: 900px) {
          .benefits-grid { grid-template-columns: repeat(2,1fr); }
          .room-grid { grid-template-columns: 1fr; }
          .join-steps { grid-template-columns: 1fr; }
          .j-step { border-right: none; border-bottom: 1px solid var(--border); }
          .j-step:last-child { border-bottom: none; }
        }
        @media (max-width: 600px) {
          .benefits-grid { grid-template-columns: 1fr; }
          .pr-hero-btns { flex-direction: column; }
        }
      `}</style>

      <div className="pr-hero">
        <div className="container pr-hero-inner">
          <span className="eyebrow" style={{color:'var(--accent)'}}>For Practitioners</span>
          <h1 style={{fontFamily:'var(--font-display)',fontSize:'clamp(34px,5vw,54px)',fontWeight:600,color:'white',lineHeight:1.1,letterSpacing:'-0.01em',marginBottom:14,maxWidth:540}}>
            A clinic you will be<br /><em style={{fontStyle:'italic',color:'var(--accent)'}}>proud to practise from.</em>
          </h1>
          <p style={{fontSize:15,color:'rgba(255,255,255,0.55)',maxWidth:500,lineHeight:1.75}}>
            {CLINIC_NAME} is a first-of-its-kind premium medical co-working space in Siddipet. Bring your expertise — we bring everything else.
          </p>
          <div className="pr-hero-btns">
            <button className="btn-accent" onClick={() => go('contact')}>Join as Practitioner →</button>
            <button style={{padding:'12px 26px',borderRadius:'var(--radius-sm)',border:'1.5px solid rgba(255,255,255,0.2)',color:'rgba(255,255,255,0.8)',fontSize:14,fontWeight:500,fontFamily:'var(--font-body)',background:'transparent',cursor:'pointer'}} onClick={() => go('contact')}>
              Enquire Now
            </button>
          </div>
        </div>
      </div>

      <section className="section benefits-section">
        <div className="container">
          <span className="eyebrow">Why Choose {CLINIC_SHORT_NAME}</span>
          <h2 className="section-title">Everything a practitioner needs</h2>
          <div className="benefits-grid">
            {BENEFITS.map(b => (
              <div key={b.title} className="ben-card">
                <div className="ben-icon">{b.icon}</div>
                <div className="ben-title">{b.title}</div>
                <div className="ben-desc">{b.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section room-showcase">
        <div className="container">
          <span className="eyebrow">Consultation Rooms</span>
          <h2 className="section-title">Your room, ready for you</h2>
          <div className="room-grid">
            <div className="room-img-side">
              <img src="/images/consultation-room.jpg" alt="Premium consultation room" />
            </div>
            <div className="room-info-side">
              <div className="room-info-title">Premium Consultation Suites</div>
              <p className="room-info-desc">Elegantly designed, fully-furnished rooms. Everything in place so you can walk in and start practising from day one.</p>
              <div className="room-tags">
                <span className="r-tag">Examination Bed</span>
                <span className="r-tag">Ergonomic Workstation</span>
                <span className="r-tag">All Specialties Welcome</span>
                <span className="r-tag">Flexible Timings</span>
                <span className="r-tag">Support Staff</span>
              </div>
              <button className="btn-terra" onClick={() => go('contact')}>Register Interest →</button>
            </div>
          </div>
        </div>
      </section>

      <section className="section spec-section">
        <div className="container">
          <span className="eyebrow">Specialties Welcome</span>
          <h2 className="section-title">All specialties, one address</h2>
          <p className="section-desc">We welcome practitioners from every medical specialty to join {CLINIC_NAME}.</p>
          <div className="spec-tags">
            {SPECIALTIES.map(s => <span key={s} className="spec-tag">{s}</span>)}
          </div>
        </div>
      </section>

      <section className="section join-section">
        <div className="container">
          <span className="eyebrow">How to Join</span>
          <h2 className="section-title">Start practising in 3 steps</h2>
          <div className="join-steps">
            {[
              { n:'01', title:'Reach Out', desc:'Contact us by phone, email or our enquiry form. Tell us about your specialty and preferred schedule.' },
              { n:'02', title:'Visit & Discuss', desc:'Tour the facility, view available rooms and discuss terms that work for your practice.' },
              { n:'03', title:'Start Practising', desc:'Move into your premium consultation room and begin seeing patients. We handle the rest.' },
            ].map(s => (
              <div key={s.n} className="j-step">
                <div className="j-num">{s.n}</div>
                <div className="j-title">{s.title}</div>
                <div className="j-desc">{s.desc}</div>
              </div>
            ))}
          </div>
          <div style={{display:'flex',justifyContent:'center',marginTop:32}}>
            <button className="btn-terra" onClick={() => go('contact')}>Enquire About Joining →</button>
          </div>
        </div>
      </section>
    </>
  );
}
